import type React from 'react';

interface MarkPulseProps {
  size?: number;
  color?: string;
  animationDuration?: number;
}

const MarkPulse: React.FC<MarkPulseProps> = ({ size = 150, color = '#000000', animationDuration = 2 }) => {
  const aspectRatio = 142 / 307;
  const height = size * aspectRatio;

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      <svg
        width={size}
        height={height}
        viewBox="0 0 307 142"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: 'relative',
        }}
      >
        <defs>
          <linearGradient id={`waveGradient-${size}`} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={color} stopOpacity="0.6">
              <animate
                attributeName="offset"
                values="-0.5; 1.5"
                dur={`${animationDuration}s`}
                repeatCount="indefinite"
              />
            </stop>
            <stop offset="30%" stopColor={color} stopOpacity="1">
              <animate
                attributeName="offset"
                values="-0.2; 1.8"
                dur={`${animationDuration}s`}
                repeatCount="indefinite"
              />
            </stop>
            <stop offset="60%" stopColor={color} stopOpacity="0.6">
              <animate
                attributeName="offset"
                values="0.1; 2.1"
                dur={`${animationDuration}s`}
                repeatCount="indefinite"
              />
            </stop>
          </linearGradient>
        </defs>
        <path
          d="M216.25 142H177.818L157.495 106.909L161.875 99.3301H191.537L216.25 142ZM38.4316 141.995H0L24.7119 99.293H63.1436L38.4316 141.995ZM83.8066 141.995H45.375L70.0879 99.293H108.52L83.8066 141.995ZM261.625 141.995H223.193L198.48 99.293H236.912L261.625 141.995ZM307 141.995H268.568L243.856 99.293H282.288L307 141.995ZM129.183 141.983H90.751L115.463 99.3135H153.895L129.183 141.983ZM232.872 92.3594H194.44L180.162 67.6855L190.58 49.6562H208.159L232.872 92.3594ZM157.944 92.3477H119.513L144.225 49.6777H182.656L157.944 92.3477ZM67.1826 92.3389H28.751L53.4639 49.6357H91.8945L67.1826 92.3389ZM112.559 92.3389H74.127L98.8389 49.6357H137.271L112.559 92.3389ZM278.247 92.3389H239.815L215.104 49.6357H253.534L278.247 92.3389ZM187.486 92.335H165.895L176.678 73.6738L187.486 92.335ZM186.608 42.708H148.177L172.889 0.0371094H211.32L186.608 42.708ZM95.8574 42.7031H57.4258L82.1377 0H120.569L95.8574 42.7031ZM141.232 42.7031H102.801L127.514 0H165.945L141.232 42.7031ZM204.208 42.7021H194.6L199.399 34.3945L204.208 42.7021ZM249.593 42.7021H211.162L202.87 28.375L219.268 0H224.881L249.593 42.7021Z"
          fill={`url(#waveGradient-${size})`}
        />
      </svg>
    </div>
  );
};

export default MarkPulse;
